import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { SizeResolver } from 'src/app/shared/directives/auto-text-resize/size-resolver';

@Directive({
  selector: '[autoTextResize]',
  standalone: false
})
export class AutoTextResizeDirective {
  constructor(
    private element: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    let sizeResolver = new SizeResolver(this.element, this.renderer);
    sizeResolver.ensureCorrectSize();
  }
}
